import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    this.resize()
  }

  resize() {
    const element = this.element

    // Store the current value
    const originalValue = element.value
    const originalPlaceholder = element.placeholder

    // Temporarily set the value to the placeholder to measure its height when empty
    if (!originalValue && originalPlaceholder) {
      element.value = originalPlaceholder
    }

    // Save current height before resetting
    const previousHeight = element.style.height

    // Hide overflow during resize to prevent scrollbar flicker
    const previousOverflow = element.style.overflowY
    element.style.overflowY = 'hidden'

    // Reset height to get the correct scrollHeight
    element.style.height = 'auto'

    // Normalize the initial height calculation
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
    const scrollHeight = element.scrollHeight
    const normalizedHeight = isSafari ? scrollHeight - 20 : scrollHeight // Adjust Safari's extra height

    // Set to scrollHeight to have content fit, with minimum of 44px
    const newHeight = Math.max(normalizedHeight, 44)
    // Apply max height of 142px
    const limitedHeight = Math.min(newHeight, 142)
    element.style.height = limitedHeight + 'px'

    // Restore the original value
    if (!originalValue && originalPlaceholder) {
      element.value = ''
    }

    // Add scrollbar if content exceeds 142px
    if (element.scrollHeight > 142) {
      element.style.overflowY = 'auto'
    } else {
      element.style.overflowY = previousOverflow || 'hidden'
    }
  }
}